// https://github.com/w3c/csswg-drafts/issues/3744
// Allow for a callback after the scroll has finished
export const scrollIntoViewAndWait = async (
  element: HTMLElement,
  scrollOption?: ScrollIntoViewOptions & {
    scrollContainer?: Nullable<HTMLElement>;
  }
) => {
  return new Promise(resolve => {
    const { scrollContainer: scrollContainerProp, ...otherOptions } =
      scrollOption || {};
    const scrollContainer = scrollContainerProp || window;
    if ('onscrollend' in scrollContainer) {
      scrollContainer.addEventListener('scrollend', resolve, { once: true });
      element.scrollIntoView(
        otherOptions || {
          block: 'center',
          inline: 'center',
          behavior: 'smooth',
        }
      );
    } else {
      element.scrollIntoView(
        otherOptions || { block: 'center', inline: 'center' }
      );
      resolve(undefined);
    }
  });
};
